import { useTranslation } from "react-i18next";
import { App } from "antd";
import useDataAdd from "@/hooks/useDataAdd";
import { SourceTypeEnum } from "@/types/common";
import { Requirement, RequirementAdd } from "@/types/requirement";
import requirementApis from "@/apis/requirement";

type AddRequirement = (data: Partial<RequirementAdd>, successCallback: (data: Requirement) => void) => Promise<void>;
type UseAddRequirement = () => [AddRequirement, boolean]

const useAddRequirement: UseAddRequirement = () => {
  const { t } = useTranslation();
  const { notification } = App.useApp();

  const { add, loading } = useDataAdd<[RequirementAdd], Requirement>({ api: requirementApis.add });

  const addRequirement: AddRequirement = async (data, successCallback) => {
    const defaultData:RequirementAdd = {
      sourceType: SourceTypeEnum.SALE_ITEM,
      sourceId: '',
      productId: '',
      bomHisId: "",
      desc: "",
      requireCount: '0',
      estimatedCost: '0',
      mrd: null,
      eps: null,
      items: [],
      confirms: []
    }

    const addInfo: RequirementAdd = {
      ...defaultData,
      ...data
    };

    try {
      const res = await add(addInfo);
      notification.success({ placement: 'top', message: t('requirement.doneSuccess') });
      successCallback(res)
    } catch (err) {      
      const map: {
        [key in number]: string;
      } = {
        72106: t('requirement.orderAlready'),
        10010: t('common.networkError'),
      };
      
      notification.error({ placement: 'top',
        message: t('common.addError'),
        description: map[err as unknown as number] ?? t('common.serverError'),
      });
    }
  };

  return [addRequirement, loading]
};

export default useAddRequirement;
